module.exports = __webpack_public_path__ + "static/media/upload-file.0be61acc.svg";